import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { AumicoPatternModule } from '@modeso/aumico-lib-core-fe';
import { I18NextModule } from 'angular-i18next';
import { AumActionBarPure } from './components/action-bar/action-bar';
import { AumicoAppLayout } from './components/app-layout/app-layout.component';
import { AppSideNav } from './components/app-sidenav/app-sidenav.component';
import { IntroLayout } from './components/intro-layout/intro-layout.component';
import { TabsNavigationComponent } from './components/tabs-navigation/tabs-navigation.component';

const EXPORTED_DECLARATIONS = [IntroLayout, AumicoAppLayout, AppSideNav, TabsNavigationComponent, AumActionBarPure];

@NgModule({
    declarations: [EXPORTED_DECLARATIONS],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        FlexLayoutModule,
        MatListModule,
        MatSidenavModule,
        MatIconModule,
        AumicoPatternModule,
        I18NextModule,
    ],
    exports: [EXPORTED_DECLARATIONS],
    providers: [],
})
export class AumicoLayoutModule2 {
    static forRoot(): ModuleWithProviders<AumicoLayoutModule2> {
        return {
            ngModule: AumicoLayoutModule2,
            providers: [],
        };
    }
}
